import script from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"

import "./TipTapEditor.vue?vue&type=style&index=0&id=f9ade4fe&lang=css"

const __exports__ = script;

export default __exports__